<template>
    <div>

        <b-tabs content-class="pt-1">
            <!-- <b-tab active title="Email Campaigns">
                <campaign/>
            </b-tab> -->
            <b-tab title="Segments">
                <Segment />
            </b-tab>
            <b-tab title="SMTP Settings">
                <Smpt />
            </b-tab>

        </b-tabs>
    </div>
</template>


<script>
import { BContainer, BCard, BCol, BRow, BButton, BModal, BFormGroup, BFormInput, BFormCheckbox, BForm, BSpinner, BTab, BTabs } from 'bootstrap-vue';
import { getProviderName, createProvider, deleteProvider, getProviders, testsmtp, updateProvider } from '@/store/smtp/services';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Smpt from "./smtp.vue";
import Segment from "./segment.vue";
import campaign from './campaign.vue';

export default {
    components: {
        BContainer, BCard, BCol, BRow, BButton, BModal, BFormGroup, BFormInput, BFormCheckbox, BForm, BSpinner, ValidationProvider, ValidationObserver, BTab, BTabs, Smpt, Segment, campaign
    },
    data() {
        return {
            providers: [
                { id: 1, name: 'SENDGRID', logo: 'https://simpauldesign.com/wp-content/uploads/2020/02/SendGrid-new-logo.png' },
                { id: 2, name: 'MAILCHIMP', logo: 'https://1000logos.net/wp-content/uploads/2023/04/Mailchimp-logo.png' },
                { id: 3, name: 'BREVO', logo: 'https://corp-backend.brevo.com/wp-content/uploads/2023/04/Dark-logo-cover.jpg' },
                { id: 4, name: 'OTHER', logo: 'https://captainverify.com/fr/blog/wp-content/uploads/2023/12/smtp-jpg.webp' }
            ],
            smtp: [],
            mainLoading: false,
            smtpConfig: {
                provider: '',
                hostName: '',
                portNumber: '',
                username: '',
                senderEmail: '',
                password: '',
                enableSSL: false,
                recipient: '',
                apiKey: ''
            },

            smtpConfigEdit: {
                id: '',
                provider: '',
                hostName: '',
                portNumber: '',
                username: '',
                senderEmail: '',
                password: '',
                enableSSL: false,
                recipient: '',
                apiKey: ''
            },
            selectedProvider: ''
        };
    },
    methods: {

        showEditSmtpModal(provider) {

            if (provider) {
                this.smtpConfigEdit = {
                    id: provider.id,
                    provider: provider.provider,
                    hostName: provider.hostName,
                    portNumber: provider.portNumber,
                    username: provider.username,
                    senderEmail: provider.senderEmail,
                    password: provider.password,
                    enableSSL: provider.enableSSL,
                    recipient: provider.recipient || '',
                    apiKey: provider.apiKey
                };
                this.selectedProvider = provider.name;
                this.modalTitle = 'Edit SMTP Configuration';
                this.actionButtonLabel = 'Save Changes';
                this.editing = true;
                this.$refs.Edit.show();
            } else {
                console.error("No SMTP settings found for provider:", provider.name);

            }
        },

        async showAddSmtpModal(providerName) {
            let payload = {
                provider: providerName
            };

            this.$swal({
                title: 'Loading...',
                text: 'Please wait while the provider details are being fetched...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            try {
                const response = await getProviderName(payload);
                console.log(response.data.result);
                this.smtpConfig.provider = response.data.result.provider;
                this.smtpConfig.hostName = response.data.result.hostName;
                this.selectedProvider = providerName;
                this.$refs.smtpModal.show();
            } catch (error) {
                console.log(error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Failed to fetch provider details. Please try again.'
                });
            } finally {
                this.$swal.close();
            }
        },
        submitSmtpForm() {
            console.log('Submitting form for:', this.selectedProvider);
            this.testSmtpConnection();
        },


        getSmtpSettings(providerName) {
            return this.smtp.find(setting => setting.provider === providerName);
        },
        async testSmtpConnection() {

            console.log(`Testing SMTP connection for ${this.selectedProvider}...`);
            let payload = { ...this.smtpConfig };
            const isValid = await this.$refs.AddForm.validate();
            if (isValid) {

                this.$swal({
                    title: 'Testing Connection...',
                    text: 'Please wait while the SMTP connection is being tested...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    const response = await testsmtp(payload);
                    this.$swal.close();

                    if (response.data && response.data.success) {
                        this.$swal.fire({
                            title: 'Success!',
                            text: 'SMTP connection successfully tested. Do you want to save these settings?',
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, save it!',
                            cancelButtonText: 'No',
                            customClass: {
                                confirmButton: "btn btn-primary",
                                cancelButton: "btn btn-outline-danger ml-1",
                            },
                            buttonsStyling: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.saveSmtpSettings();
                            }
                        });
                    } else {
                        throw new Error(response.data.message || 'Unknown error');
                    }
                } catch (error) {
                    console.error('SMTP test failed:', error);
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed!',
                        text: `SMTP test failed: ${error.response.data.message}. Please check the details and try again.`
                    });
                }
            }


        },

        async testSmtpConnectionEdit() {
            console.log(`Testing SMTP connection for ${this.selectedProvider}...`);
            let payload = { ...this.smtpConfigEdit };

            const isValid = await this.$refs.EditForm.validate();

            if (isValid) {
                this.$swal({
                    title: 'Testing Connection...',
                    text: 'Please wait while the SMTP connection is being tested...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    const response = await testsmtp(payload);
                    this.$swal.close();

                    if (response.data && response.data.success) {
                        this.$swal.fire({
                            title: 'Success!',
                            text: 'SMTP connection successfully tested. Do you want to updated these settings?',
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, update it!',
                            cancelButtonText: 'No',
                            customClass: {
                                confirmButton: "btn btn-primary",
                                cancelButton: "btn btn-outline-danger ml-1",
                            },
                            buttonsStyling: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.updateSmtpSettings();
                            }
                        });
                    } else {
                        throw new Error(response.data.message || 'Unknown error');
                    }
                } catch (error) {
                    console.error('SMTP test failed:', error);
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed!',
                        text: `SMTP test failed: ${error.response.data.message}. Please check the details and try again.`
                    });
                }
            }
        },
        deleteSmtp(smtpId) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Deleting...',
                        text: 'Please wait while the SMTP settings are being deleted...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                    // Assume deleteProvider is an async function that deletes the SMTP settings by ID
                    deleteProvider(smtpId).then(response => {
                        this.$swal.hideLoading();
                        console.log('Delete response:', response);
                        if (response && (response.status === 200)) {
                            this.$swal.fire(
                                'Deleted!',
                                'Your SMTP settings have been deleted.',
                                'success'
                            );
                            // Refresh the SMTP settings list or remove the deleted settings from the local state
                            this.getSMPT();
                        } else {
                            throw new Error('Failed to delete settings.');
                        }
                    }).catch(error => {
                        this.$swal.fire(
                            'Failed to Delete!',
                            error.message || 'There was a problem deleting the SMTP settings.',
                            'error'
                        );

                    });
                }
            });
        },



        async updateSmtpSettings() {


            const isValid = await this.$refs.EditForm.validate();
            if (isValid) {
                this.$swal({
                    title: 'Saving Settings...',
                    text: 'Please wait while the SMTP settings are being updated...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    const response = await updateProvider(this.smtpConfigEdit);
                    this.$swal.close();

                    if (response.data && response.data.success) {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Saved!',
                            text: 'SMTP settings have been successfully updated.'
                        });
                        await this.getSMPT();
                        this.$refs.Edit.hide();
                    } else {
                        throw new Error(response.data.message || 'Failed to save settings.');
                    }
                } catch (error) {
                    console.error('Save settings failed:', error);
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed to Save!',
                        text: `${error.message}. Please try again.`
                    });
                    await this.getSMPT();
                }

            }

        },

        async saveSmtpSettings() {
            const isValid = await this.$refs.AddForm.validate();

            if (isValid) {
                this.$swal({
                    title: 'Saving Settings...',
                    text: 'Please wait while the SMTP settings are being saved...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    const response = await createProvider(this.smtpConfig);
                    this.$swal.close();

                    if (response.data && response.data.success) {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Saved!',
                            text: 'SMTP settings have been successfully saved.'
                        });
                        await this.getSMPT();
                        this.$refs.smtpModal.hide();
                    } else {
                        throw new Error(response.data.message || 'Failed to save settings.');
                    }
                } catch (error) {
                    console.error('Save settings failed:', error);
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed to Save!',
                        text: `${error.message}. Please try again.`
                    });
                    await this.getSMPT();


                }
            }

        },


        async getSMPT() {
            this.mainLoading = true;
            try {
                const response = await getProviders();
                this.smtp = response.data.result;
            } catch (error) {
                console.log(error);
            }
            finally {
                this.mainLoading = false;
            }
        }


    },

    async mounted() {
        await this.getSMPT();
    }
};
</script>


<style>
/* Add any custom styles here */
</style>